import { useSelector } from "react-redux";

const useLoggedIn = () => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);

  // redux-persist may still be rehydrating on first load
  const isLoggedIn = isAuthenticated && !!user;
  const isLoading = loading;

  return { isLoggedIn, isLoading };
};

export default useLoggedIn;
